import { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import API from "../services/api";
import WhatsAppPreview from "../components/WhatsAppPreview";
import {creditMessage, paymentMessage, simulateCredit, reminderMessage} from "../services/whatsappService";

import PageHeader from "../components/PageHeader";
import CreditCard from "../components/CreditCard";
import Card from "../components/Card";
import Button from "../components/Button";
import Modal from "../components/Modal";
import FormInput from "../components/FormInput";
import Toast from "../components/Toast";
import { uploadFile } from "../services/uploadService";

const getLocalDateInputValue = () => {
  const today = new Date();
  const offset = today.getTimezoneOffset() * 60000;
  return new Date(today.getTime() - offset).toISOString().slice(0, 10);
};

function ClientDetail() {
  const [refinanceCredit, setRefinanceCredit] = useState(null);
  const [documentUrls, setDocumentUrls] = useState({});
  const [openRefinanceModal, setOpenRefinanceModal] = useState(false);

  const handleRefinanceClick = (credit) => {
    setRefinanceCredit(credit);
    setRefinanceDate(getLocalDateInputValue());
    setOpenRefinanceModal(true);
  };
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const [whatsappDraft, setWhatsappDraft] = useState(null);
  const shareCredit = (credit, kind = 'Crédito', origin) => {
    const operator = typeof credit.operador === 'object' ? credit.operador : operators.find(o => o._id === credit.operador);
    setWhatsappDraft({phone: client?.telefono || '', text: creditMessage(client,credit,operator,kind,origin)});
  };
  const previewSimulation = () => {
    try { const c=simulateCredit(capital,interes,cuotas,creditInterestType,creditStartDate); shareCredit({...c,operador:selectedOperator},'Simulación'); }
    catch(e) { setToast({message:e.message,type:'error'}); }
  };
  const [creditSearch, setCreditSearch] = useState('');
  const [credits, setCredits] = useState([]);
  const creditSearchQuery = creditSearch.replace(/\s/g, '');
  const filteredCredits = credits.filter(credit => {
    const level = String(credit.nivelRefinanciacion || 0).padStart(2, '0');
    const number = String(credit.codigoDirecto || 0).padStart(4, '0');
    if (!creditSearchQuery) return true;
    if (creditSearchQuery.includes('-')) {
      const parts = creditSearchQuery.split('-');
      return parts.length === 2 && /^\d+$/.test(parts[0]) && /^\d+$/.test(parts[1]) &&
        Number(parts[0]) === Number(level) && Number(parts[1]) === Number(number);
    }
    return /^\d+$/.test(creditSearchQuery) && number.includes(creditSearchQuery);
  });
  const [client, setClient] = useState(null);
  const [history, setHistory] = useState([]);
  const [actions, setActions] = useState([]);
  const [refinanceInterest, setRefinanceInterest] = useState("");

  const [refinanceDate, setRefinanceDate] = useState(getLocalDateInputValue);

  const [refinanceInstallments, setRefinanceInstallments] = useState(1);

  const [refinanceType, setRefinanceType] = useState("PORCENTAJE");

  const [openActionModal, setOpenActionModal] = useState(false);

  const [actionType, setActionType] = useState("WHATSAPP");

  const [actionDetail, setActionDetail] = useState("");
  const [fechaCompromiso, setFechaCompromiso] = useState("");

  const [montoCompromiso, setMontoCompromiso] = useState("");
  const [, setUploading] = useState(false);
  const totalPrestado = credits
    .filter((credit) => !credit.creditoOrigen)
    .reduce((acc, credit) => acc + (credit.capital || 0), 0);

  const totalFinanciado = credits
    .filter((credit) => !credit.creditoOrigen)
    .reduce((acc, credit) => acc + (credit.total || 0), 0);

  const saldoPendiente = credits.reduce(
    (acc, credit) => acc + (credit.saldoPendiente || 0),
    0,
  );

  const creditosActivos = credits.filter(
    (c) =>
      c.activo === true && c.estado !== "PAGADO" && c.estado !== "REFINANCIADO",
  ).length;

  const [monto, setMonto] = useState("");
  const [selectedCredit, setSelectedCredit] = useState("");
  const [paymentDate, setPaymentDate] = useState(getLocalDateInputValue);
  const [paymentReceiver, setPaymentReceiver] = useState("OPERADOR");
  const [paymentMethod, setPaymentMethod] = useState("EFECTIVO");

  const [toast, setToast] = useState(null);

  const [openCreditModal, setOpenCreditModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [showClientInfo, setShowClientInfo] = useState(false);

  const [editNombre, setEditNombre] = useState("");
  const [editTelefono, setEditTelefono] = useState("");
  const [editDireccion, setEditDireccion] = useState("");
  const [editDni, setEditDni] = useState("");
  const [editCuil, setEditCuil] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editEmpresa, setEditEmpresa] = useState("");
  const [editOcupacion, setEditOcupacion] = useState("");
  const [editIngresos, setEditIngresos] = useState("");
  const [editObservaciones, setEditObservaciones] = useState("");

  const [capital, setCapital] = useState("");
  const [interes, setInteres] = useState("");
  const [cuotas, setCuotas] = useState("");
  const [creditStartDate, setCreditStartDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [creditInterestType, setCreditInterestType] = useState("PORCENTAJE");
  const [creditToEdit, setCreditToEdit] = useState(null);
  const [editCreditCapital, setEditCreditCapital] = useState("");
  const [editCreditInterest, setEditCreditInterest] = useState("");
  const [editCreditInterestType, setEditCreditInterestType] = useState("PORCENTAJE");
  const [editCreditOperator, setEditCreditOperator] = useState("");
  const [operators, setOperators] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [editApellido, setEditApellido] = useState("");

  const [editFechaNacimiento, setEditFechaNacimiento] = useState("");
  const [editSexo, setEditSexo] = useState("");
  const [editNacionalidad, setEditNacionalidad] = useState("");
  const [editEstadoCivil, setEditEstadoCivil] = useState("");
  const [editCategoria, setEditCategoria] = useState("C");

  const [editProvincia, setEditProvincia] = useState("");
  const [editLocalidad, setEditLocalidad] = useState("");
  const [editCodigoPostal, setEditCodigoPostal] = useState("");

  const [editAntiguedadLaboral, setEditAntiguedadLaboral] = useState("");

  const [editReferenciaNombre, setEditReferenciaNombre] = useState("");
  const [editReferenciaTelefono, setEditReferenciaTelefono] = useState("");
  const [editReferenciaRelacion, setEditReferenciaRelacion] = useState("");

  const [editAlias, setEditAlias] = useState("");
  const [editCbu, setEditCbu] = useState("");

  const loadClientData = useCallback(async () => {
    try {
      const resClient = await API.get(`/clients/${id}`);
      setClient(resClient.data);
      const resCredits = await API.get(`/credits/client/${id}`);
      setCredits(resCredits.data);

      const resHistory = await API.get(`/clients/${id}/history`);
      setHistory(resHistory.data);
      const resActions = await API.get(`/collections/client/${id}`);

      setActions(resActions.data);
    } catch (error) {
      console.error(error);
    }
  }, [id]);
  const openEditClient = () => {
    if (!client) return;

    setEditNombre(client.nombre || "");
    setEditTelefono(client.telefono || "");
    setEditDireccion(client.direccion || "");
    setEditDni(client.dni || "");
    setEditCuil(client.cuil || "");
    setEditEmail(client.email || "");
    setEditEmpresa(client.empresa || "");
    setEditOcupacion(client.ocupacion || "");
    setEditIngresos(client.ingresosMensuales || "");
    setEditObservaciones(client.observaciones || "");
    setEditApellido(client.apellido || "");

    setEditFechaNacimiento(
      client.fechaNacimiento ? client.fechaNacimiento.split("T")[0] : "",
    );

    setEditSexo(client.sexo || "");
    setEditNacionalidad(client.nacionalidad || "");
    setEditEstadoCivil(client.estadoCivil || "");
    setEditCategoria(client.categoria || "C");

    setEditProvincia(client.provincia || "");
    setEditLocalidad(client.localidad || "");
    setEditCodigoPostal(client.codigoPostal || "");

    setEditAntiguedadLaboral(client.antiguedadLaboral || "");

    setEditReferenciaNombre(client.referenciaNombre || "");

    setEditReferenciaTelefono(client.referenciaTelefono || "");

    setEditReferenciaRelacion(client.referenciaRelacion || "");

    setEditAlias(client.alias || "");
    setEditCbu(client.cbu || "");

    setOpenEditModal(true);
  };
  const loadOperators = async () => {
    try {
      const res = await API.get("/operators");

      setOperators(res.data.filter((operator) => operator.activo));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadClientData();
  }, [loadClientData]);

  useEffect(() => {
    return () => {
      Object.values(documentUrls).forEach((url) => {
        if (url) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [documentUrls]);

  const loadDocument = async (filename) => {
    if (!filename) {
      return null;
    }

    try {
      const response = await API.get(
        `/uploads/${encodeURIComponent(filename)}`,
        {
          responseType: "blob",
        },
      );

      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  useEffect(() => {
    if (!client) {
      return;
    }

    const loadDocuments = async () => {
      const fields = [
        "fotoPerfil",
        "dniFrente",
        "dniDorso",
        "reciboSueldo",
        "comprobanteDomicilio",
      ];

      const urls = {};

      for (const field of fields) {
        if (client[field]) {
          const url = await loadDocument(client[field]);

          if (url) {
            urls[field] = url;
          }
        }
      }

      setDocumentUrls(urls);
    };

    loadDocuments();
  }, [client]);

  useEffect(() => {
    loadOperators();
  }, []);

  useEffect(() => {
    if (!client) return;
    const action = searchParams.get("action");
    if (action === "credit") setOpenCreditModal(true);
    if (action === "payment") {
      const timer = window.setTimeout(() => document.getElementById("payment-section")?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
      return () => window.clearTimeout(timer);
    }
  }, [client, searchParams]);

  const handlePago = async () => {
    try {
      if (!monto || monto <= 0) {
        setToast({
          message: "Ingresá un monto válido",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      if (!selectedCredit) {
        setToast({
          message: "Seleccioná un crédito",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      const creditSelected = credits.find((c) => c._id === selectedCredit);

      if (!creditSelected) {
        setToast({
          message: "Error al encontrar el crédito",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      if (Number(monto) > creditSelected.saldoPendiente) {
        setToast({
          message: "No podés pagar más que el saldo",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      const paymentResponse = await API.post("/payments", {
        credito: selectedCredit,
        monto: Number(monto),
        recibidoPor: paymentReceiver,
        medioPago: paymentMethod,
        fecha: paymentDate,
      });

      await loadClientData();

      try {
        const fresh = await API.get('/credits/client/'+id);
        const paidCredit = fresh.data.find(c => c._id === selectedCredit);
        if(paidCredit) setWhatsappDraft({phone:client?.telefono||'',text:paymentMessage(client,paidCredit,paymentResponse.data)});
      } catch(e) { setToast({message:'El pago fue guardado. No se pudo preparar su mensaje; revisá el historial.',type:'error'}); }
      setMonto("");
      setPaymentReceiver("OPERADOR");
      setPaymentMethod("EFECTIVO");
      setPaymentDate(getLocalDateInputValue());

      setToast({
        message: "Pago registrado correctamente",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      const message = error.response?.data?.error || "Error al registrar pago";

      setToast({
        message,
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  };

  const handleCreateCredit = async () => {
    try {
      if (capital === "" || interes === "" || cuotas === "") {
        setToast({
          message: "Completá todos los campos",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      if (!selectedOperator) {
        setToast({
          message: "Seleccioná un operador",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      const creditPayload = {
        cliente: id,
        operador: selectedOperator,
        capital: Number(capital),
        interes: Number(interes),
        cuotas: Number(cuotas),
        tipoInteres: creditInterestType,
        fechaInicio: creditStartDate,
      };

      let createdCredit;
      try {
        createdCredit = (await API.post("/credits", creditPayload)).data;
      } catch (error) {
        const requiresConfirmation =
          error.response?.status === 409 &&
          error.response?.data?.code === "ACTIVE_CREDIT_CONFIRMATION_REQUIRED";

        if (!requiresConfirmation) {
          throw error;
        }

        const shouldContinue = window.confirm(
          "Este cliente ya tiene un crédito activo. ¿Querés crearle un crédito nuevo igualmente?",
        );

        if (!shouldContinue) {
          return;
        }

        createdCredit = (await API.post("/credits", {
          ...creditPayload,
          permitirCreditoActivo: true,
        })).data;
      }

      await loadClientData();

      setOpenCreditModal(false);
      shareCredit(createdCredit);

      setCapital("");
      setInteres("");
      setCuotas("");
      setCreditStartDate(new Date().toISOString().slice(0, 10));
      setSelectedOperator("");
      setCreditInterestType("PORCENTAJE");

      setToast({
        message: "Crédito creado correctamente",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      const message = error.response?.data?.error || "Error al crear crédito";

      setToast({
        message,
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  };

  const handleCancelCredit = async (credit) => {
    if (!window.confirm("¿Querés cancelar este crédito? Esta acción solo está disponible si no tiene pagos y no se puede deshacer.")) {
      return;
    }

    try {
      await API.delete(`/credits/${credit._id}`);
      await loadClientData();
      setToast({ message: "Crédito cancelado correctamente", type: "success" });
      window.setTimeout(() => setToast(null), 3000);
    } catch (error) {
      setToast({
        message: error.response?.data?.error || "Error al cancelar el crédito",
        type: "error",
      });
      window.setTimeout(() => setToast(null), 3000);
    }
  };

  const handleActivateLateFee = async (credit) => {
    if (!window.confirm("¿Querés activar ahora el recargo por morosidad de este crédito?")) return;

    try {
      await API.post(`/credits/${credit._id}/activate-late-fee`);
      await loadClientData();
      setToast({ message: "Recargo moratorio activado", type: "success" });
      window.setTimeout(() => setToast(null), 3000);
    } catch (error) {
      setToast({ message: error.response?.data?.error || "Error al activar la morosidad", type: "error" });
      window.setTimeout(() => setToast(null), 3000);
    }
  };

  const handleRemoveLateFee = async (credit) => {
    if (!window.confirm("¿Querés quitar los recargos moratorios y dejar el saldo real del crédito?")) return;

    try {
      await API.post(`/credits/${credit._id}/remove-late-fee`);
      await loadClientData();
      setToast({ message: "Recargo moratorio quitado", type: "success" });
      window.setTimeout(() => setToast(null), 3000);
    } catch (error) {
      setToast({ message: error.response?.data?.error || "Error al quitar el recargo", type: "error" });
      window.setTimeout(() => setToast(null), 3000);
    }
  };

  const openEditCredit = (credit) => {
    setCreditToEdit(credit);
    setEditCreditCapital(String(credit.capital || ""));
    setEditCreditInterest(String(credit.tipoInteres === "PORCENTAJE"
      ? credit.capital
        ? ((credit.interes || 0) / credit.capital) * 100
        : 0
      : credit.interes || ""));
    setEditCreditInterestType(credit.tipoInteres || "PORCENTAJE");
    setEditCreditOperator(credit.operador?._id || credit.operador || "");
  };

  const handleUpdateCredit = async () => {
    if (!creditToEdit) return;

    try {
      await API.put(`/credits/${creditToEdit._id}`, {
        capital: Number(editCreditCapital),
        interes: Number(editCreditInterest),
        tipoInteres: editCreditInterestType,
        operador: editCreditOperator,
      });

      await loadClientData();
      setCreditToEdit(null);
      setToast({ message: "Valores del crédito actualizados", type: "success" });
      setTimeout(() => setToast(null), 3000);
    } catch (error) {
      setToast({
        message: error.response?.data?.error || "Error al actualizar el crédito",
        type: "error",
      });
      setTimeout(() => setToast(null), 3000);
    }
  };

  const handleUpdateClient = async () => {
    try {
      await API.put(`/clients/${id}`, {
        nombre: editNombre,
        telefono: editTelefono,
        direccion: editDireccion,
        dni: editDni,
        cuil: editCuil,
        email: editEmail,
        empresa: editEmpresa,
        ocupacion: editOcupacion,
        ingresosMensuales: Number(editIngresos) || 0,
        observaciones: editObservaciones,
        apellido: editApellido,

        fechaNacimiento: editFechaNacimiento,
        sexo: editSexo,
        nacionalidad: editNacionalidad,
        estadoCivil: editEstadoCivil,
        categoria: editCategoria,

        provincia: editProvincia,
        localidad: editLocalidad,
        codigoPostal: editCodigoPostal,

        antiguedadLaboral: editAntiguedadLaboral,

        referenciaNombre: editReferenciaNombre,
        referenciaTelefono: editReferenciaTelefono,
        referenciaRelacion: editReferenciaRelacion,

        alias: editAlias,
        cbu: editCbu,
      });

      await loadClientData();

      setOpenEditModal(false);

      setToast({
        message: "Cliente actualizado correctamente",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      setToast({
        message: "Error al actualizar cliente",
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  };
  const handleCreateRefinance = async () => {
    try {
      const refinanceResponse = await API.post("/credits/refinance", {
        creditId: refinanceCredit._id,

        interes: Number(refinanceInterest),

        cuotas: Number(refinanceInstallments),

        tipoInteres: refinanceType,

        fechaInicio: refinanceDate,
      });

      setToast({
        message: "Refinanciación creada correctamente",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);

      setOpenRefinanceModal(false);

      shareCredit(refinanceResponse.data, "Refinanciación", refinanceCredit);
      setRefinanceCredit(null);

      setRefinanceInterest("");

      setRefinanceInstallments(1);

      setRefinanceDate(getLocalDateInputValue());

      loadClientData();
    } catch (error) {
      console.error(error);

      const message =
        error.response?.data?.error || "Error al crear la refinanciación";

      setToast({
        message,
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 4000);
    }
  };
  const handleCreateAction = async () => {
    try {
      if (!actionDetail.trim()) {
        setToast({
          message: "Ingresá un detalle",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      if (actionType === "PROMESA_PAGO") {
        if (!fechaCompromiso) {
          setToast({
            message: "Ingresá la fecha de compromiso",
            type: "error",
          });

          setTimeout(() => {
            setToast(null);
          }, 3000);

          return;
        }

        if (montoCompromiso === "" || Number(montoCompromiso) <= 0) {
          setToast({
            message: "Ingresá un monto comprometido válido",
            type: "error",
          });

          setTimeout(() => {
            setToast(null);
          }, 3000);

          return;
        }
      }

      await API.post("/collections", {
        cliente: id,
        tipo: actionType,
        detalle: actionDetail,

        fechaCompromiso: actionType === "PROMESA_PAGO" ? fechaCompromiso : null,

        montoCompromiso:
          actionType === "PROMESA_PAGO" ? Number(montoCompromiso) : 0,
      });

      await loadClientData();

      setActionDetail("");

      setActionType("WHATSAPP");

      setOpenActionModal(false);

      setToast({
        message: "Gestión registrada",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      setToast({
        message: "Error al registrar gestión",
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  };
  const handleUploadDocument = async (event, tipo, campo) => {
    try {
      const file = event.target.files[0];

      if (!file) return;

      setUploading(true);

      const uploaded = await uploadFile(file, tipo);

      await API.put(`/clients/${id}`, {
        [campo]: uploaded.filename,
      });

      await loadClientData();

      setToast({
        message: "Documento cargado",
        type: "success",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } catch (error) {
      console.error(error);

      setToast({
        message: "Error al subir archivo",
        type: "error",
      });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    } finally {
      setUploading(false);
    }
  };
  const handleWhatsApp = async () => {
    try {
      if (!client?.telefono) {
        setToast({
          message: "El cliente no tiene teléfono cargado",
          type: "error",
        });

        setTimeout(() => {
          setToast(null);
        }, 3000);

        return;
      }

      const telefono = client.telefono.replace(/\D/g, "");

      const mensaje = `Hola ${client.nombre}. Nos comunicamos desde ClinCash.`;

      window.open(
        `https://wa.me/54${telefono}?text=${encodeURIComponent(mensaje)}`,
        "_blank",
        "noopener,noreferrer",
      );

      await API.post("/collections", {
        cliente: id,
        tipo: "WHATSAPP",
        detalle: "Contacto iniciado por WhatsApp",
      });

      await loadClientData();
    } catch (error) {
      console.error(error);
    }
  };

  const getColorEstado = (estado) => {
    if (estado === "PAGADO") {
      return "#dcfce7";
    }

    if (estado === "MOROSO") {
      return "#fee2e2";
    }

    if (estado === "PAGO50") {
      return "#dbeafe";
    }

    if (estado === "REFINANCIADO") {
      return "#ede9fe";
    }

    return "#fef3c7";
  };

  const formatMoney = (num) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
    }).format(num);
  };
  const formatCreditCode = (credit) => `${String(credit.nivelRefinanciacion || 0).padStart(2, "0")}-${String(credit.codigoDirecto || 0).padStart(4, "0")}`;
  const creditosPagados = credits.filter((c) => c.estado === "PAGADO").length;

  const creditosMorosos = credits.filter((c) => c.estado === "MOROSO").length;

  const cumplimiento =
    credits.length > 0
      ? Math.round((creditosPagados / credits.length) * 100)
      : 0;

  const categoriaSugerida =
    cumplimiento >= 90
      ? "A"
      : cumplimiento >= 75
        ? "B"
        : cumplimiento >= 50
          ? "C"
          : "D";

  const ultimoPago = history.find((item) => item.tipo === "PAGO") || null;

  const ultimaGestion = actions.length > 0 ? actions[0] : null;

  const proximoVencimiento = credits
    .filter(
      (c) =>
        c.activo === true &&
        c.estado !== "PAGADO" &&
        c.estado !== "REFINANCIADO",
    )
    .sort(
      (a, b) => new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento),
    )[0];

  const timeline = [
    ...history.map((item) => ({
      tipo: item.tipo,
      fecha: item.fecha,
      descripcion:
        item.tipo === "PAGO"
          ? `Pago de ${formatMoney(item.monto || 0)} · ${item.recibidoPor === "ADMIN" ? "recibido por administrador" : "recibido por operador"} · ${item.medioPago === "TRANSFERENCIA" ? "transferencia" : "efectivo"}`
          : `Crédito ${formatCreditCode(item)} por ${formatMoney(item.monto || 0)}`,
    })),

    ...actions.map((item) => ({
      tipo: item.tipo,
      fecha: item.createdAt,
      descripcion: item.detalle,
    })),
  ].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  const renderPaymentSection = () => (
    <Card
      id="payment-section"
      style={{
        marginBottom: 20,
        border: "1px solid #fed7aa",
        boxShadow: "0 10px 24px rgba(249,115,22,0.08)",
      }}
    >
      <h2 style={{ marginTop: 0, marginBottom: 6 }}>Registrar Pago</h2>
      <p style={{ marginTop: 0, marginBottom: 16, color: "#6b7280", fontSize: 14 }}>
        Registrá un pago rápido sobre un crédito activo
      </p>

      <select className="cc-select" value={selectedCredit} onChange={(e) => setSelectedCredit(e.target.value)}>
        <option value="">Seleccionar crédito</option>
        {credits
          .filter((c) => c.activo === true && c.estado !== "PAGADO" && c.estado !== "REFINANCIADO")
          .map((c) => (
            <option key={c._id} value={c._id}>
              {formatCreditCode(c)} · {c.fechaInicio ? new Date(c.fechaInicio).toLocaleDateString("es-AR") : "Sin fecha"} · Saldo {formatMoney(c.saldoPendiente)}
            </option>
          ))}
      </select>

      {credits.filter((c) => c._id === selectedCredit).map((c) => (
        <div className="cc-payment-credit-summary" key={c._id}>
          <div><span>Crédito</span><strong>{formatCreditCode(c)}</strong></div>
          <div><span>Otorgamiento</span><strong>{c.fechaInicio ? new Date(c.fechaInicio).toLocaleDateString("es-AR") : "—"}</strong></div>
          <div><span>Capital</span><strong>{formatMoney(c.capital)}</strong></div>
          <div><span>Interés {c.tipoInteres === "PORCENTAJE" && c.capital > 0 ? `(${new Intl.NumberFormat("es-AR", { maximumFractionDigits: 2 }).format(c.interes / c.capital * 100)}%)` : "fijo"}</span><strong>{formatMoney(c.interes)}</strong></div>
          <div><span>Total con interés</span><strong>{formatMoney(c.total)}</strong></div>
          <div><span>Recargos</span><strong>{formatMoney(c.recargoAcumulado || 0)}</strong></div>
          <div><span>Abonado</span><strong>{formatMoney(c.totalPagado || 0)}</strong></div>
          <div><span>Saldo a pagar</span><strong>{formatMoney(c.saldoPendiente)}</strong></div>
        </div>
      ))}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 }}>
        <FormInput
          label="Monto"
          type="number"
          thousandSeparator
          placeholder="5000"
          value={monto}
          onChange={(e) => setMonto(e.target.value)}
        />

        <FormInput
          label="Fecha del pago"
          type="date"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
        />

        <div>
          <label className="cc-form-label">Quién recibió el pago</label>
          <select className="cc-select" value={paymentReceiver} onChange={(e) => setPaymentReceiver(e.target.value)}>
            <option value="OPERADOR">Lo recibió el operador</option>
            <option value="ADMIN">Pago al administrador</option>
          </select>
        </div>

        <div>
          <label className="cc-form-label">Medio de pago</label>
          <select className="cc-select" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
            <option value="EFECTIVO">Efectivo</option>
            <option value="TRANSFERENCIA">Transferencia</option>
          </select>
        </div>
      </div>

      <Button onClick={handlePago}>Registrar Pago</Button>
    </Card>
  );

  return (
    <div>
      {toast && <Toast message={toast.message} type={toast.type} />}
      {whatsappDraft && <WhatsAppPreview key={whatsappDraft.text} draft={whatsappDraft} onClose={() => setWhatsappDraft(null)} />}

      <PageHeader
        title="Detalle del Cliente"
        subtitle={client ? `${client.nombre} ${client.apellido || ""} · Créditos, pagos e historial` : "Cargando cliente…"}
        action={
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <Button variant="secondary" onClick={openEditClient}>
              Editar Cliente
            </Button>

            <Button
              onClick={handleWhatsApp}
              style={{
                backgroundColor: "#22c55e",
              }}
            >
              WhatsApp
            </Button>

            <Button onClick={() => setOpenCreditModal(true)}>
              + Nuevo Crédito
            </Button>

            <Modal
              open={openEditModal}
              onClose={() => setOpenEditModal(false)}
              title="Editar Cliente"
            >
              <FormInput
                label="Nombre"
                value={editNombre}
                onChange={(e) => setEditNombre(e.target.value)}
              />

              <FormInput
                label="Apellido"
                value={editApellido}
                onChange={(e) => setEditApellido(e.target.value)}
              />

              <FormInput
                label="Fecha Nacimiento"
                type="date"
                value={editFechaNacimiento}
                onChange={(e) => setEditFechaNacimiento(e.target.value)}
              />

              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                Sexo
              </label>

              <select
                value={editSexo}
                onChange={(e) => setEditSexo(e.target.value)}
                style={{
                  width: "100%",
                  padding: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  marginBottom: 20,
                }}
              >
                <option value="">Seleccionar sexo</option>
                <option value="MASCULINO">Masculino</option>
                <option value="FEMENINO">Femenino</option>
                <option value="OTRO">Otro</option>
              </select>

              <FormInput
                label="Nacionalidad"
                value={editNacionalidad}
                onChange={(e) => setEditNacionalidad(e.target.value)}
              />

              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                Estado Civil
              </label>

              <select
                value={editEstadoCivil}
                onChange={(e) => setEditEstadoCivil(e.target.value)}
                style={{
                  width: "100%",
                  padding: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  marginBottom: 20,
                }}
              >
                <option value="">Seleccionar estado civil</option>
                <option value="SOLTERO">Soltero/a</option>
                <option value="CASADO">Casado/a</option>
                <option value="DIVORCIADO">Divorciado/a</option>
                <option value="VIUDO">Viudo/a</option>
                <option value="SEPARADO">Separado/a</option>
                <option value="UNION_CONVIVENCIAL">Unión convivencial</option>
                <option value="OTRO">Otro</option>
              </select>

              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                Categoría
              </label>

              <select
                value={editCategoria}
                onChange={(e) => setEditCategoria(e.target.value)}
                style={{
                  width: "100%",
                  padding: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  marginBottom: 20,
                }}
              >
                <option value="A">A - Excelente</option>
                <option value="B">B - Bueno</option>
                <option value="C">C - Normal</option>
                <option value="D">D - Riesgoso</option>
              </select>

              <FormInput
                label="Teléfono"
                value={editTelefono}
                onChange={(e) => setEditTelefono(e.target.value)}
              />

              <FormInput
                label="Email"
                value={editEmail}
                onChange={(e) => setEditEmail(e.target.value)}
              />

              <FormInput
                label="Dirección"
                value={editDireccion}
                onChange={(e) => setEditDireccion(e.target.value)}
              />

              <FormInput
                label="Provincia"
                value={editProvincia}
                onChange={(e) => setEditProvincia(e.target.value)}
              />

              <FormInput
                label="Localidad"
                value={editLocalidad}
                onChange={(e) => setEditLocalidad(e.target.value)}
              />

              <FormInput
                label="Código Postal"
                value={editCodigoPostal}
                onChange={(e) => setEditCodigoPostal(e.target.value)}
              />

              <FormInput
                label="DNI"
                value={editDni}
                onChange={(e) => setEditDni(e.target.value)}
              />

              <FormInput
                label="CUIL"
                value={editCuil}
                onChange={(e) => setEditCuil(e.target.value)}
              />

              <FormInput
                label="Empresa"
                value={editEmpresa}
                onChange={(e) => setEditEmpresa(e.target.value)}
              />

              <FormInput
                label="Ocupación"
                value={editOcupacion}
                onChange={(e) => setEditOcupacion(e.target.value)}
              />

              <FormInput
                label="Ingresos Mensuales"
                thousandSeparator
                value={editIngresos}
                onChange={(e) => setEditIngresos(e.target.value)}
              />

              <FormInput
                label="Antigüedad Laboral"
                value={editAntiguedadLaboral}
                onChange={(e) => setEditAntiguedadLaboral(e.target.value)}
              />

              <FormInput
                label="Referencia Nombre"
                value={editReferenciaNombre}
                onChange={(e) => setEditReferenciaNombre(e.target.value)}
              />

              <FormInput
                label="Referencia Teléfono"
                value={editReferenciaTelefono}
                onChange={(e) => setEditReferenciaTelefono(e.target.value)}
              />

              <FormInput
                label="Referencia Relación"
                value={editReferenciaRelacion}
                onChange={(e) => setEditReferenciaRelacion(e.target.value)}
              />

              <FormInput
                label="Alias"
                value={editAlias}
                onChange={(e) => setEditAlias(e.target.value)}
              />

              <FormInput
                label="CBU"
                value={editCbu}
                onChange={(e) => setEditCbu(e.target.value)}
              />

              <FormInput
                label="Observaciones"
                value={editObservaciones}
                onChange={(e) => setEditObservaciones(e.target.value)}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 12,
                  marginTop: 20,
                }}
              >
                <Button
                  variant="secondary"
                  onClick={() => setOpenEditModal(false)}
                >
                  Cancelar
                </Button>

                <Button onClick={handleUpdateClient}>Guardar Cambios</Button>
              </div>
            </Modal>
          </div>
        }
      />
      {renderPaymentSection()}
      {client && (
        <Card
          style={{
            marginBottom: 20,
          }}
        >
          <h2 style={{ marginTop: 0 }}>Información del Cliente</h2>
          <div
            style={{
              display: "flex",
              gap: 24,
              alignItems: "center",
              marginBottom: 30,
              paddingBottom: 20,
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div>
              {client.fotoPerfil && documentUrls.fotoPerfil ? (
                <img
                  src={documentUrls.fotoPerfil}
                  alt="Perfil"
                  style={{
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #e5e7eb"
                  }}
                />
              ) : (
                <div
                  style={{
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    backgroundColor: "#f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 40,
                    fontWeight: 700,
                    color: "#6b7280",
                  }}
                >
                  {client.nombre?.charAt(0)}
                </div>
              )}
            </div>

            <div>
              <h1
                style={{
                  margin: 0,
                }}
              >
                {client.nombre}
              </h1>

              <div
                style={{
                  display: "flex",
                  gap: 10,
                  marginTop: 10,
                }}
              >
                <span
                  style={{
                    backgroundColor:
                      client.estado === "MOROSO" ? "#dc2626" : "#16a34a",
                    color: "white",
                    padding: "6px 12px",
                    borderRadius: 999,
                    fontWeight: 700,
                  }}
                >
                  {client.estado}
                </span>

                <span
                  style={{
                    backgroundColor: "#2563eb",
                    color: "white",
                    padding: "6px 12px",
                    borderRadius: 999,
                    fontWeight: 700,
                  }}
                >
                  Categoría {client.categoria || "C"}
                </span>
              </div>
            </div>
          </div>

          <div
            onClick={() => setShowClientInfo(!showClientInfo)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
              userSelect: "none",
              padding: "12px 0",
              borderTop: "1px solid #e5e7eb",
              borderBottom: showClientInfo ? "none" : "1px solid #e5e7eb",
              marginBottom: showClientInfo ? 20 : 0,
            }}
          >
            <h3 style={{ margin: 0 }}>Datos Personales</h3>

            <span
              style={{
                fontSize: 20,
                color: "#6b7280",
              }}
            >
              {showClientInfo ? "▲" : "▼"}
            </span>
          </div>
          {showClientInfo && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <div>
                  <strong>Nombre</strong>
                  <p>{client.nombre || "-"}</p>
                </div>

                <div>
                  <strong>Apellido</strong>
                  <p>{client.apellido || "-"}</p>
                </div>

                <div>
                  <strong>DNI</strong>
                  <p>{client.dni || "-"}</p>
                </div>

                <div>
                  <strong>CUIL</strong>
                  <p>{client.cuil || "-"}</p>
                </div>

                <div>
                  <strong>Fecha Nacimiento</strong>
                  <p>
                    {client.fechaNacimiento
                      ? client.fechaNacimiento.split("-").reverse().join("/")
                      : "-"}
                  </p>
                </div>

                <div>
                  <strong>Sexo</strong>
                  <p>{client.sexo || "-"}</p>
                </div>

                <div>
                  <strong>Nacionalidad</strong>
                  <p>{client.nacionalidad || "-"}</p>
                </div>

                <div>
                  <strong>Estado Civil</strong>
                  <p>{client.estadoCivil || "-"}</p>
                </div>
                <div>
                  <strong>Categoría</strong>
                  <p>{client.categoria || "C"}</p>
                </div>
              </div>

              <h3>Contacto</h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <div>
                  <strong>Teléfono</strong>
                  <p>{client.telefono || "-"}</p>
                </div>

                <div>
                  <strong>Email</strong>
                  <p>{client.email || "-"}</p>
                </div>

                <div>
                  <strong>Dirección</strong>
                  <p>{client.direccion || "-"}</p>
                </div>

                <div>
                  <strong>Provincia</strong>
                  <p>{client.provincia || "-"}</p>
                </div>

                <div>
                  <strong>Localidad</strong>
                  <p>{client.localidad || "-"}</p>
                </div>

                <div>
                  <strong>Código Postal</strong>
                  <p>{client.codigoPostal || "-"}</p>
                </div>
              </div>

              <h3>Información Laboral</h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <div>
                  <strong>Empresa</strong>
                  <p>{client.empresa || "-"}</p>
                </div>

                <div>
                  <strong>Ocupación</strong>
                  <p>{client.ocupacion || "-"}</p>
                </div>

                <div>
                  <strong>Ingresos</strong>
                  <p>
                    {client.ingresosMensuales
                      ? formatMoney(client.ingresosMensuales)
                      : "-"}
                  </p>
                </div>

                <div>
                  <strong>Antigüedad Laboral</strong>
                  <p>{client.antiguedadLaboral || "-"}</p>
                </div>
              </div>

              <h3>Referencias</h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <div>
                  <strong>Nombre</strong>
                  <p>{client.referenciaNombre || "-"}</p>
                </div>

                <div>
                  <strong>Teléfono</strong>
                  <p>{client.referenciaTelefono || "-"}</p>
                </div>

                <div>
                  <strong>Relación</strong>
                  <p>{client.referenciaRelacion || "-"}</p>
                </div>
              </div>

              <h3>Datos Bancarios</h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <div>
                  <strong>Alias</strong>
                  <p>{client.alias || "-"}</p>
                </div>

                <div>
                  <strong>CBU</strong>
                  <p>{client.cbu || "-"}</p>
                </div>
              </div>
              <h3>Documentación</h3>

              <div
                style={{
                  display: "grid",
                  gap: 12,
                  marginBottom: 24,
                }}
              >
                <div>
                  <strong>DNI Frente</strong>

                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 8,
                      alignItems: "center",
                    }}
                  >
                    {client.dniFrente &&
                      documentUrls.dniFrente && (
                        <a
                          href={documentUrls.dniFrente}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Ver Documento
                        </a>
                      )}

                    <input
                      type="file"
                      onChange={(e) =>
                        handleUploadDocument(e, "dni", "dniFrente")
                      }
                    />
                  </div>
                </div>

                <div>
                  <strong>DNI Dorso</strong>

                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 8,
                      alignItems: "center",
                    }}
                  >
                    {client.dniDorso &&
                      documentUrls.dniDorso && (
                        <a
                          href={documentUrls.dniDorso}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Ver Documento
                        </a>
                      )}

                    <input
                      type="file"
                      onChange={(e) =>
                        handleUploadDocument(e, "dni", "dniDorso")
                      }
                    />
                  </div>
                </div>

                <div>
                  <strong>Recibo de Sueldo</strong>

                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 8,
                      alignItems: "center",
                    }}
                  >
                    {client.reciboSueldo &&
                      documentUrls.reciboSueldo && (
                        <a
                          href={documentUrls.reciboSueldo}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Ver Documento
                        </a>
                      )}

                    <input
                      type="file"
                      onChange={(e) =>
                        handleUploadDocument(e, "recibo", "reciboSueldo")
                      }
                    />
                  </div>
                </div>

                <div>
                  <strong>Comprobante Domicilio</strong>

                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      marginTop: 8,
                      alignItems: "center",
                    }}
                  >
                    {client.comprobanteDomicilio &&
                      documentUrls.comprobanteDomicilio && (
                        <a
                          href={documentUrls.comprobanteDomicilio}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Ver Documento
                        </a>
                      )}

                    <input
                      type="file"
                      onChange={(e) =>
                        handleUploadDocument(
                          e,
                          "domicilio",
                          "comprobanteDomicilio",
                        )
                      }
                    />
                  </div>
                </div>

                <div>
                  <strong>Foto Perfil</strong>

                  {client.fotoPerfil && (
                    <div
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                      }}
                    >
                      <img
                        src={documentUrls.fotoPerfil}
                        alt="Perfil"
                        style={{
                          width: 120,
                          height: 120,
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid #e5e7eb"
                        }}
                      />
                    </div>
                  )}

                  <input
                    type="file"
                    onChange={(e) =>
                      handleUploadDocument(e, "perfil", "fotoPerfil")
                    }
                  />
                </div>
              </div>

              <h3>Estado Financiero</h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                }}
              >
                <div>
                  <strong>Estado</strong>
                  <p>{client.estado || "-"}</p>
                </div>

                <div>
                  <strong>Operador</strong>
                  <p>{client.operador || "-"}</p>
                </div>

                <div>
                  <strong>Activo</strong>
                  <p>{client.activo ? "Sí" : "No"}</p>
                </div>
              </div>

              {client.observaciones && (
                <div
                  style={{
                    marginTop: 24,
                  }}
                >
                  <h3>Observaciones</h3>

                  <p>{client.observaciones}</p>
                </div>
              )}
            </>
          )}
        </Card>
      )}
      <Card
        style={{
          marginBottom: 20,
        }}
      >
        <h2 style={{ marginTop: 0 }}>Perfil de Riesgo</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 16,
          }}
        >
          <div>
            <strong>Créditos Pagados</strong>
            <p>{creditosPagados}</p>
          </div>

          <div>
            <strong>Créditos Morosos</strong>
            <p>{creditosMorosos}</p>
          </div>

          <div>
            <strong>Cumplimiento</strong>
            <p>{cumplimiento}%</p>
          </div>

          <div>
            <strong>Categoría Sugerida</strong>

            <p
              style={{
                fontWeight: 700,
                color:
                  categoriaSugerida === "A"
                    ? "#16a34a"
                    : categoriaSugerida === "B"
                      ? "#2563eb"
                      : categoriaSugerida === "C"
                        ? "#f59e0b"
                        : "#dc2626",
              }}
            >
              <span
                style={{
                  padding: "6px 12px",
                  borderRadius: 999,
                  color: "white",
                  fontWeight: 700,
                  backgroundColor:
                    categoriaSugerida === "A"
                      ? "#16a34a"
                      : categoriaSugerida === "B"
                        ? "#2563eb"
                        : categoriaSugerida === "C"
                          ? "#f59e0b"
                          : "#dc2626",
                }}
              >
                {categoriaSugerida}
              </span>
            </p>
          </div>
        </div>
      </Card>
      <Card
        style={{
          marginBottom: 20,
        }}
      >
        <h2 style={{ marginTop: 0 }}>Resumen de Cobranza</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 16,
          }}
        >
          <div>
            <strong>Saldo Pendiente</strong>
            <p>{formatMoney(saldoPendiente)}</p>
          </div>

          <div>
            <strong>Último Pago</strong>
            <p>
              {ultimoPago
                ? new Date(ultimoPago.fecha).toLocaleDateString()
                : "-"}
            </p>
          </div>

          <div>
            <strong>Última Gestión</strong>
            <p>{ultimaGestion ? ultimaGestion.tipo : "-"}</p>
          </div>

          <div>
            <strong>Próximo Vencimiento</strong>
            <p>
              {proximoVencimiento
                ? new Date(
                    proximoVencimiento.fechaVencimiento,
                  ).toLocaleDateString()
                : "-"}
            </p>
          </div>
        </div>
      </Card>
      <Card
        style={{
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ marginTop: 0 }}>Gestiones de Cobranza</h2>

          <Button onClick={() => setOpenActionModal(true)}>
            + Nueva Gestión
          </Button>
        </div>
        <Modal
          open={openRefinanceModal}
          onClose={() => setOpenRefinanceModal(false)}
          title="Refinanciar Crédito"
        >
          {refinanceCredit && (
            <>
              <div
                style={{
                  marginBottom: 20,
                }}
              >
                <strong>Saldo a Refinanciar</strong>

                <p
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                  }}
                >
                  {formatMoney(refinanceCredit.saldoPendiente)}
                </p>
              </div>

              <FormInput
                label="Interés"
                thousandSeparator={refinanceType === "FIJO"}
                value={refinanceInterest}
                onChange={(e) => setRefinanceInterest(e.target.value)}
              />

              <FormInput
                label="Fecha de refinanciación"
                type="date"
                value={refinanceDate}
                onChange={(e) => setRefinanceDate(e.target.value)}
              />

              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                Tipo de Interés
              </label>

              <select
                value={refinanceType}
                onChange={(e) => setRefinanceType(e.target.value)}
                style={{
                  width: "100%",
                  padding: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  marginBottom: 20,
                }}
              >
                <option value="PORCENTAJE">Porcentaje</option>

                <option value="FIJO">Fijo</option>
              </select>

              <FormInput
                label="Cuotas"
                type="number"
                value={refinanceInstallments}
                onChange={(e) => setRefinanceInstallments(e.target.value)}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 12,
                  marginTop: 20,
                }}
              >
                <Button
                  variant="secondary"
                  onClick={() => setOpenRefinanceModal(false)}
                >
                  Cancelar
                </Button>

                <Button onClick={handleCreateRefinance}>
                  Crear Refinanciación
                </Button>
              </div>
            </>
          )}
        </Modal>

        {actions.length === 0 ? (
          <p>No hay gestiones registradas</p>
        ) : (
          actions.map((action) => (
            <div
              key={action._id}
              style={{
                padding: "12px 0",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontWeight: 700,
                }}
              >
                {action.tipo}
              </p>

              <p
                style={{
                  margin: "6px 0",
                }}
              >
                {action.detalle}
              </p>

              <p
                style={{
                  margin: 0,
                  color: "#6b7280",
                  fontSize: 14,
                }}
              >
                {new Date(action.createdAt).toLocaleString()}
              </p>
            </div>
          ))
        )}
      </Card>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 16,
          marginBottom: 20,
        }}
      >
        <Card>
          <h3 style={{ marginTop: 0 }}>Total Prestado</h3>

          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
            }}
          >
            {formatMoney(totalPrestado)}
          </p>
        </Card>

        <Card>
          <h3 style={{ marginTop: 0 }}>Total Financiado</h3>

          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
            }}
          >
            {formatMoney(totalFinanciado)}
          </p>
        </Card>

        <Card>
          <h3 style={{ marginTop: 0 }}>Saldo Pendiente</h3>

          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
              color: "#dc2626",
            }}
          >
            {formatMoney(saldoPendiente)}
          </p>
        </Card>

        <Card>
          <h3 style={{ marginTop: 0 }}>Créditos Activos</h3>

          <p
            style={{
              fontSize: 28,
              fontWeight: 700,
              margin: 0,
            }}
          >
            {creditosActivos}
          </p>
        </Card>
      </div>

      <Card
        style={{
          marginBottom: 20,
        }}
      >
        <div className="cc-credits-heading">
          <h2>Créditos</h2>
          <div className="cc-credit-search">
            <input id="credit-code-search" aria-label="Buscar por código de crédito" type="search" placeholder="Buscar código: 00-0017" value={creditSearch} onChange={e => setCreditSearch(e.target.value)} />
            {creditSearch && <Button variant="secondary" onClick={() => setCreditSearch('')}>Limpiar</Button>}
          </div>
        </div>
        {creditSearchQuery && <p role="status" style={{color:'#6b7280',fontSize:13}}>{filteredCredits.length} de {credits.length} créditos</p>}
        {filteredCredits.length === 0 && <p>{creditSearchQuery ? 'No hay créditos que coincidan con ese código para este cliente.' : 'Este cliente todavía no tiene créditos.'}</p>}

        {[...filteredCredits].sort((a, b) => new Date(b.fechaInicio || b.createdAt) - new Date(a.fechaInicio || a.createdAt)).map((c) => (
          <CreditCard
            key={c._id}
            credit={c}
            formatMoney={formatMoney}
            getColorEstado={getColorEstado}
            onReminder={(credit,stage) => setWhatsappDraft({phone:client?.telefono||"",text:reminderMessage(client,credit,stage)})}
            onShare={shareCredit}
            onRefinance={handleRefinanceClick}
            onEdit={openEditCredit}
            onCancel={handleCancelCredit}
            onActivateLateFee={handleActivateLateFee}
            onRemoveLateFee={handleRemoveLateFee}
          />
        ))}
      </Card>

      <Card>
        <h2 style={{ marginTop: 0 }}>Historial</h2>

        {timeline.length === 0 ? (
          <p>No hay movimientos registrados</p>
        ) : (
          timeline.map((item, index) => (
            <div
              key={index}
              style={{
                padding: "12px 0",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontWeight: 700,
                }}
              >
                {item.tipo}
              </p>

              <p
                style={{
                  margin: "6px 0",
                }}
              >
                {item.descripcion}
              </p>

              <p
                style={{
                  margin: 0,
                  color: "#6b7280",
                  fontSize: 14,
                }}
              >
                {new Date(item.fecha).toLocaleString()}
              </p>
            </div>
          ))
        )}
      </Card>

      <Modal
        open={openActionModal}
        onClose={() => setOpenActionModal(false)}
        title="Nueva Gestión"
      >
        <label
          style={{
            display: "block",
            marginBottom: 8,
            fontWeight: 600,
          }}
        >
          Tipo
        </label>

        <select
          value={actionType}
          onChange={(e) => setActionType(e.target.value)}
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 12,
            border: "1px solid #e5e7eb",
            marginBottom: 20,
          }}
        >
          <option value="WHATSAPP">WhatsApp</option>
          <option value="LLAMADA">Llamada</option>
          <option value="VISITA">Visita</option>
          <option value="PROMESA_PAGO">Promesa de Pago</option>
          <option value="OTRO">Otro</option>
        </select>

        {actionType === "PROMESA_PAGO" && (
          <>
            <FormInput
              label="Fecha Compromiso"
              type="date"
              value={fechaCompromiso}
              onChange={(e) => setFechaCompromiso(e.target.value)}
            />

            <FormInput
              label="Monto Compromiso"
              type="number"
              thousandSeparator
              value={montoCompromiso}
              onChange={(e) => setMontoCompromiso(e.target.value)}
            />
          </>
        )}

        <FormInput
          label="Detalle"
          value={actionDetail}
          onChange={(e) => setActionDetail(e.target.value)}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 20,
          }}
        >
          <Button variant="secondary" onClick={() => setOpenActionModal(false)}>
            Cancelar
          </Button>

          <Button onClick={handleCreateAction}>Guardar</Button>
        </div>
      </Modal>
      <Modal
        open={openCreditModal}
        onClose={() => setOpenCreditModal(false)}
        title="Nuevo Crédito"
      >
        <label
          style={{
            display: "block",
            marginBottom: 8,
            fontWeight: 600,
          }}
        >
          Operador
        </label>

        <select
          value={selectedOperator}
          onChange={(e) => setSelectedOperator(e.target.value)}
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 12,
            border: "1px solid #e5e7eb",
            marginBottom: 20,
          }}
        >
          <option value="">Seleccionar operador</option>

          {operators.map((operator) => (
            <option key={operator._id} value={operator._id}>
              {operator.nombre} {operator.apellido} - {operator.comision}%
            </option>
          ))}
        </select>

        <FormInput
          label="Capital"
          type="number"
          thousandSeparator
          placeholder="50000"
          value={capital}
          onChange={(e) => setCapital(e.target.value)}
        />

        <FormInput
          label="Fecha de otorgamiento"
          type="date"
          value={creditStartDate}
          onChange={(e) => setCreditStartDate(e.target.value)}
        />
        <label
          style={{
            display: "block",
            marginBottom: 8,
            fontWeight: 600,
          }}
        >
          Tipo de Interés
        </label>

        <select
          value={creditInterestType}
          onChange={(e) => setCreditInterestType(e.target.value)}
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 12,
            border: "1px solid #e5e7eb",
            marginBottom: 20,
          }}
        >
          <option value="PORCENTAJE">Porcentaje</option>

          <option value="FIJO">Fijo</option>
        </select>

        <FormInput
          label={
            creditInterestType === "PORCENTAJE" ? "Interés (%)" : "Interés ($)"
          }
          type="number"
          thousandSeparator={creditInterestType === "FIJO"}
          placeholder="20"
          value={interes}
          onChange={(e) => setInteres(e.target.value)}
        />

        <FormInput
          label="Cuotas"
          type="number"
          placeholder="12"
          value={cuotas}
          onChange={(e) => setCuotas(e.target.value)}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 20,
          }}
        >
          <Button variant="secondary" onClick={() => setOpenCreditModal(false)}>
            Cancelar
          </Button>

          <Button variant="secondary" onClick={previewSimulation}>Simular y compartir</Button>
          <Button onClick={handleCreateCredit}>Crear Crédito</Button>
        </div>
      </Modal>

      <Modal
        open={Boolean(creditToEdit)}
        onClose={() => setCreditToEdit(null)}
        title="Editar valores del crédito"
      >
        <p style={{ color: "#6b7280", marginTop: 0 }}>
          Las fechas del crédito no se modifican. Se recalcularán el total, saldo,
          cuota y comisión.
        </p>

        <FormInput
          label="Capital"
          type="number"
          thousandSeparator
          value={editCreditCapital}
          onChange={(e) => setEditCreditCapital(e.target.value)}
        />

        <label style={{ display: "block", marginBottom: 8, fontWeight: 600 }}>
          Tipo de Interés
        </label>
        <select
          value={editCreditInterestType}
          onChange={(e) => setEditCreditInterestType(e.target.value)}
          style={{ width: "100%", padding: 12, borderRadius: 12, border: "1px solid #e5e7eb", marginBottom: 20 }}
        >
          <option value="PORCENTAJE">Porcentaje</option>
          <option value="FIJO">Fijo</option>
        </select>

        <FormInput
          label={editCreditInterestType === "PORCENTAJE" ? "Interés (%)" : "Interés ($)"}
          type="number"
          thousandSeparator={editCreditInterestType === "FIJO"}
          value={editCreditInterest}
          onChange={(e) => setEditCreditInterest(e.target.value)}
        />

        <label style={{ display: "block", marginBottom: 8, fontWeight: 600 }}>
          Operador
        </label>
        <select
          value={editCreditOperator}
          onChange={(e) => setEditCreditOperator(e.target.value)}
          style={{ width: "100%", padding: 12, borderRadius: 12, border: "1px solid #e5e7eb", marginBottom: 20 }}
        >
          <option value="">Seleccionar operador</option>
          {operators.map((operator) => (
            <option key={operator._id} value={operator._id}>
              {operator.nombre} {operator.apellido} - {operator.comision}%
            </option>
          ))}
        </select>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 20 }}>
          <Button variant="secondary" onClick={() => setCreditToEdit(null)}>Cancelar</Button>
          <Button onClick={handleUpdateCredit}>Guardar cambios</Button>
        </div>
      </Modal>

    </div>
  );
}

export default ClientDetail;
